import { IModel } from "@/@types/models/model";
import { coreFields } from "./helpers/coreFields";
import { commonFields } from "./helpers/commonFields";
import { buttonFields } from "./helpers/buttonFields";

const Zemljovidi: IModel = {
  title: "Zemljovidi",
  apiPath: "zemljovidi",
  forms : {
    "default": {
      fields: ["naziv", "godina", "projekt_id", "br", "autor", "web", "potrage", "baza", "avenza_map", "locus_map"]
    },
    "overlay": {
      fields: ["naziv", "godina", "avenza_map", "locus_map"]
    }
  },
  listViews: {
    "default": {
      fields: ["id", "godina", "naziv", "projekt_id", "br", "autor", "web", "potrage", "baza", "avenza_map", "locus_map"],
      hidden: ["id"]
    },
    "sidebar": {
      fields: ["id", "naziv", "godina", "show_on_map"],
      hidden: ["id"]
    }
  },
  fields: [
    coreFields.id,
    {
      title: "godina",
      source: "godina",
      ttoken: "data.godina",
      type: "numeric"
    },
    {
      title: "Naziv",
      source: "naziv",
      ttoken: "data.naziv",
      type: "text",
      validation: {
        maxLength: 50
      }
    },
    {
      title: "Projekt ID",
      source: "projekt_id",
      ttoken: "data.projekt_id",
      type: "text",
      validation: {
        maxLength: 10
      }
    },
    {
      title: "br",
      source: "br",
      ttoken: "data.br",
      type: "numeric",
      filterType: "text"
    },
    {
      title: "autor",
      source: "autor",
      ttoken: "data.autor",
      type: "text",
      validation: {
        maxLength: 150
      }
    },
    {
      title: "web",
      source: "web",
      ttoken: "data.web",
      type: "radio",
      row: true,
      items: {
        values: [1, 0, ''],
        labels: ["common.yes", "common.no", "common.unknown"]
      }
    },
    {
      title: "potrage",
      source: "potrage",
      ttoken: "data.potrage",
      type: "radio",
      row: true,
      items: {
        values: [1, 0, ''],
        labels: ["common.yes", "common.no", "common.unknown"]
      }
    },
    {
      title: "baza",
      source: "baza",
      ttoken: "data.baza",
      type: "radio",
      row: true,
      items: {
        values: [1, 0, ''],
        labels: ["common.yes", "common.no", "common.unknown"]
      }
    },
    {
      title: "avenza_map",
      source: "avenza_map",
      ttoken: "data.avenza_map",
      type: "radio",
      row: true,
      items: {
        values: [1, 0, ''],
        labels: ["common.yes", "common.no", "common.unknown"]
      }
    },
    {
      title: "locus_map",
      source: "locus_map",
      ttoken: "data.locus_map",
      type: "radio",
      row: true,
      items: {
        values: [1, 0, ''],
        labels: ["common.yes", "common.no", "common.unknown"]
      }
    },
    commonFields.wkt,
    commonFields.proj,
    buttonFields.show_on_map,
    {
      title: "",
      source: "avenza_url",
      tooltip: "buttons.avenza_url",
      ttoken: "",
      type: "button",
      icon: "avenza",
      action: "avenza",
      padding: "none",
      sort: false
    },
    {
      title: "",
      source: "locus_url",
      tooltip: "buttons.locus_url",
      ttoken: "",
      type: "button",
      icon: "locus",
      action: "locus",
      padding: "none",
      sort: false
    }
  ]
}

export default Zemljovidi;